import { Box, styled } from '@mui/material';

/** 양식 본문 안 로딩·오류 안내 박스 */
const ApprovalNoticeBox = styled(Box)`
  padding: 16px 12px;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 4px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text-strong, #4d5157);
`;

export default ApprovalNoticeBox;
